import type {
  GetSettings200AimManualWorkloadsItem,
  PatchSettingsBodyAimManualWorkloadsItem,
} from '@ipfabric/api-client/client/schemas';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import { AimWorkloadsTable } from '../components/ApplicationMapping/tables/AimWorkloadsTable';
import type { DiscoverySettingsObject } from '../model/DiscoverySettingsObject';
import type { AimWorkloadDraft } from '../model/aimDrafts';

type AimWorkloadsFieldValues = { aimWorkloads: AimWorkloadDraft[] };

export const storedAimWorkloads: FormSnippet<
  DiscoverySettingsObject,
  AimWorkloadsFieldValues
> = {
  render: ({ form }) => <AimWorkloadsTable form={form as never} />,

  fromModel: (model, draft) => {
    draft.aimWorkloads = (model.aim?.manual?.workloads ?? []).map((w) => ({
      id: w.id,
      applicationId: w.applicationId,
      name: w.name,
      ipAddress: w.ipAddress,
      interfaces: w.interfaces?.map((i) => i.ipAddress) ?? [],
    }));
  },

  toModel: (values, modelDraft) => {
    modelDraft.aim ??= {
      integrations: [],
      manual: { applications: [], workloads: [], flows: [] },
    };
    modelDraft.aim.manual ??= { applications: [], workloads: [], flows: [] };
    // PATCH DTO omits server-generated timestamps; cast to satisfy the model
    // field type (GetSettings200AimManualWorkloadsItem[]) which the immer draft uses.
    modelDraft.aim.manual.workloads = values.aimWorkloads.map(
      (w): PatchSettingsBodyAimManualWorkloadsItem => ({
        id: w.id,
        applicationId: w.applicationId,
        name: w.name,
        ipAddress: w.ipAddress,
        interfaces: w.interfaces?.map((ipAddress) => ({ ipAddress })) ?? [],
      }),
    ) as GetSettings200AimManualWorkloadsItem[];
  },

  schema: z.object({
    aimWorkloads: z.array(z.unknown()),
  }) as z.Schema<AimWorkloadsFieldValues>,
};
